import React from "react";

export const DateDisplay = ({ dateString }: { dateString: string }) => {
    let date = new Date(dateString);

    return <span>{date.toLocaleString()}</span>;
};
